import React, { useState, useEffect } from 'react';
import { useLoginSettings } from '../contexts/loginSettingsContext';
import useDarkMode from '../hooks/useDarkMode';

const Logo = () => {
	const { loginSettings, loginSettingsLang } = useLoginSettings();
const { darkModeStatus } = useDarkMode();
	return (
		<img
			style={{ width: '160px', height: '40px', objectFit: 'contain', fontSize: '20px' }}
			src={darkModeStatus ? loginSettings.site_logo_dark : loginSettings.site_logo}
			alt='Site Logo'
		/>
	);
};
Logo.propTypes = {};
Logo.defaultProps = {};

export default Logo;
